var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { applyPositions } from '../helpers';
import { forceDirectedLayout } from '../layouts';
/** Apply force layout to an existing diagram group */
export function applyForceLayout(group, edges, options) {
    var e_1, _a;
    var _b;
    var nodes = [];
    try {
        for (var _c = __values(group.children), _d = _c.next(); !_d.done; _d = _c.next()) {
            var child = _d.value;
            var id = (_b = child.metadata) === null || _b === void 0 ? void 0 : _b.diagramId;
            if (id)
                nodes.push({ id: id, x: child.x, y: child.y });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var positions = forceDirectedLayout(nodes, edges, options);
    applyPositions(group, positions);
}
